var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.eventType)?_c('span',{staticClass:"aircraft-event-type-label",class:`aircraft-event-type-label--${_vm.eventType}`},[_vm._v(" "+_vm._s(_vm.$t(_vm.eventType === 'audio' ? 'aircraftAudioEvent' : 'aircraftVideoEvent'))+" ")]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }